import { Info } from 'lucide-react';
import { Icon, Tooltip } from '../../../ds/components';
import styles from './calculator.module.css';

/**
 * The (i) next to one of Nico Kremer's inputs (D-347): a focusable button whose explanation shows as a DS tooltip
 * on hover and keyboard focus; the explanation is also its accessible description.
 */
export function InfoTip({ label, text }: { label: string; text: string }) {
  return (
    <Tooltip content={text}>
      <button type="button" className={styles.infoTip} aria-label={`Erläuterung: ${label}`}>
        <Icon icon={Info} size={16} />
      </button>
    </Tooltip>
  );
}
